import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const steps = [
  { number: '01', title: 'Prise de contact', desc: 'Envoyez-nous un message ou appelez-nous pour présenter votre projet en quelques mots.' },
  { number: '02', title: 'Consultation initiale', desc: 'Rencontre de 60 à 90 minutes pour analyser votre espace, comprendre vos goûts et définir vos objectifs.' },
  { number: '03', title: 'Remise du rapport', desc: "Vous recevez un plan d'action détaillé, des recommandations et un moodboard sous 5 jours ouvrés." },
  { number: '04', title: 'Décision libre', desc: 'Vous êtes libre de mettre en oeuvre nos conseils vous-même ou de nous confier la réalisation complète.' },
];

const ProcessSection = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-brand-beige py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-brand-coral" />
            <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">Comment ça marche</span>
            <span className="h-px w-6 bg-brand-coral" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-brand-anthracite mb-4">Le Processus</h2>
          <p className="text-brand-gray max-w-xl mx-auto text-base leading-relaxed">
            Un accompagnement simple, transparent et centré sur vos besoins.
          </p>
        </div>

        <div ref={ref} className="relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-brand-gold/30" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {steps.map((step, idx) => (
              <div
                key={step.number}
                className={`relative text-center transition-all duration-600 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${idx * 150}ms`, transitionDuration: '600ms' }}
              >
                {/* Circle */}
                <div
                  className="w-20 h-20 flex items-center justify-center rounded-full mx-auto mb-5 relative z-10 border-2 border-white"
                  style={{ background: 'linear-gradient(135deg, #e63e8b, #f78b49)' }}
                >
                  <span className="font-serif text-xl font-bold text-white">{step.number}</span>
                </div>
                <h3 className="font-serif text-lg font-semibold text-brand-anthracite mb-3">{step.title}</h3>
                <p className="text-sm text-brand-gray leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
